export const baseURL = process.env.NODE_ENV === "development"
  ? "http://localhost:8000"
  : "https://backendlive.neurolingua.in";
console.log(baseURL);

export const getToken = () => {
  const token = JSON.parse(localStorage.getItem("profile"))?.token;
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  return config;
};
